import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="print"
// Opens the browser's print dialog, which also saves as PDF.
export default class extends Controller {
  print () {
    window.print()
  }
}
